import * as API from '@/api'
import request from './index'

//获取卡口管理员列表
export function getListNp() {
    return request.get(API.KA_ADMIN_LIST_NP)
}

//获取厂区管理员列表
export function getList(params) {
    return request.get(API.KA_ADMIN_LIST, {
        params
    })
}

//添加厂区管理员
export function add(data) {
    return request.post(API.KA_ADMIN_ADD, data)
}

//修改厂区管理员
export function edit(data) {
    return request.post(API.KA_ADMIN_EDIT, data)
}

//删除厂区管理员
export function del(id) {
    return request.get(API.KA_ADMIN_DEL, {
        params: {
            id
        }
    })
}
